import { useEffect, useRef } from 'react';
import { Button } from './Button';

export function LoadMore({
  state,
  onLoad,
  loaded,
  total,
  automatic = false,
  itemLabel = 'строки',
}: {
  state: 'idle' | 'loading' | 'error' | 'complete';
  onLoad: () => void;
  loaded: number;
  total: number;
  automatic?: boolean;
  itemLabel?: 'строки' | 'сообщения';
}) {
  const sentinel = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = sentinel.current;
    if (!automatic || state !== 'idle' || !el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) onLoad();
      },
      { root: el.closest('[data-scrollport]'), rootMargin: '160px' },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [automatic, state, onLoad]);

  return (
    <div
      ref={sentinel}
      data-slot="load-more"
      className="flex flex-wrap items-center justify-between gap-3 px-3 py-4"
    >
      <span role="status" className="text-xs text-fg-muted">
        {state === 'loading'
          ? 'Загружаем следующие ' + itemLabel + '…'
          : state === 'error'
            ? 'Не удалось загрузить ' + itemLabel + '.'
            : `Показано ${loaded} из ${total}`}
      </span>
      {state === 'error' ? (
        <Button variant="secondary" size="sm" onClick={onLoad}>
          Повторить загрузку
        </Button>
      ) : (
        state !== 'complete' && (
          <Button variant="ghost" size="sm" onClick={onLoad} disabled={state === 'loading'}>
            Загрузить ещё
          </Button>
        )
      )}
    </div>
  );
}
